import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import { accommodationIndividualRoomTileGridChildEnforcer } from './AccommodationIndividualRoomRoomTileGridBase'
import type { SetOptional } from 'type-fest'

export const AccommodationIndividualRoomTilePricingContainer = styled(Group)`
  grid-area: pricing;
  ${accommodationIndividualRoomTileGridChildEnforcer}
  position: relative;

  margin-top: ${rem(8)};
  ${mediaQueryUp.desktop} {
    margin-top: unset;
  }
`

interface Props extends SetOptional<React.ComponentProps<typeof Group>, 'direction' | 'gap' | 'horizontalAlign' | 'desktopDirection' | 'desktopVerticalAlign'> {}

function AccommodationIndividualRoomTilePricing({ children, ...rest }: React.PropsWithChildren<Props>) {
  return <AccommodationIndividualRoomTilePricingContainer direction="horizontal" gap={8} horizontalAlign="stretch" desktopDirection="vertical" desktopVerticalAlign="end" {...rest}>
    {children}
  </AccommodationIndividualRoomTilePricingContainer>
}

export default AccommodationIndividualRoomTilePricing
